<template>

    <div class="changepassword mt-5">
        <h3>{{ lang('all.wachtwoord_wijzigen') }}</h3>

        <text-input
            v-model="form.current_password"
            type="password"
            :errors="errors.current_password"
            :placeholder="lang('all.voer_hier_je_huidige_wachtwoord_in')"
        ></text-input>

        <text-input
            v-model="form.password"
            type="password"
            :placeholder="lang('all.voer_hier_je_nieuwe_wachtwoord_in')"
            :errors="errors.password"
        ></text-input>

        <text-input
            v-model="form.password_confirmation"
            type="password"
            :placeholder="lang('all.bevestig_hier_je_nieuwe_wachtwoord')"
        ></text-input>

        <p><strong>{{ lang('all.let_op') }} </strong>{{ lang('all.na_het_wijzigen_van_je_wachtwoord_zul_je_automatis') }}</p>

        <div>
            <button
                class="btn btn-primary"
                :disabled="!canChangePassword"
                @click="changePassword"
            >
                {{ lang('all.wachtwoord_wijzigen') }}
            </button>
        </div>
    </div>

</template>

<script>

import TextInput from "../../Common/TextInput";

export default {

    components: {
        TextInput,
    },

    computed: {
        canChangePassword(){
            return this.posting === false &&
                this.form.current_password !== '' &&
                this.form.password !== '' &&
                this.form.password === this.form.password_confirmation;
        },
        errors() {
            return this.$page.props.errors;
        },
    },

    data() {
        return {
            form: {
                current_password:'',
                password:'',
                password_confirmation:'',
            },
            posting:false,
        }
    },

    methods:{
        changePassword(){
            if (!this.canChangePassword) {
                return;
            }
            this.posting = true;
            this.$inertia.post(this.route('auth.myaccount.details.changepassword.store'), this.form, {
                onFinish: () => this.posting = false,
            });
        },
    },

    name:'MyAccountChangePassword',

}

</script>
